// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-profile-container-IMgqp {
  width: 324px;
  position: absolute;
  top: 60px;
  right: 24px;
  background-color: white;
  border-radius: var(--radius-lg);
  outline: none;
  box-shadow: var(--shadow-xl);
  border: 1px solid var(--color-neutral-200);
  padding: 20px 20px 24px;
  z-index: 3;
}

.user-profile-animation_enter-k4vPu {
  opacity: 0.5;
  transform: translateY(-16px);
}

.user-profile-animation_enterActive-KfsH9 {
  opacity: 1;
  transform: translateY(0px);
  transition: opacity 150ms ease-out, transform 180ms ease-out;
}

.user-profile-animation_exit-DlGtT {
  opacity: 1;
  transform: translateY(0px);
}

.user-profile-animation_exitActive-nDUT7 {
  opacity: 0.1;
  transform: translateY(-16px);
  transition: opacity 150ms linear, transform 180ms linear;
}

.user-profile-role-h_0rm {
  font-size: 16px;
  margin-top: 12px;
}

.user-profile-email-MyOv5 {
  color: var(--accent-color);
  font-weight: 500;
  margin-top: 12px;
}

.user-profile-logoutButton_base-CvaJ3 {
  width: 100%;
  justify-content: start;
  margin-top: 32px;
  padding: 0px 12px;
}

.user-profile-logoutButton_icon-DNRh0 {
  --size: 22px;
  margin-right: 12px;
}

.user-profile-logoutButton_text-j08eV {
  font-size: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/components/user-profile/user-profile.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,+BAA+B;EAC/B,aAAa;EACb,4BAA4B;EAC5B,0CAA0C;EAC1C,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,4DAA4D;AAC9D;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,wDAAwD;AAC1D;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".container {\n  width: 324px;\n  position: absolute;\n  top: 60px;\n  right: 24px;\n  background-color: white;\n  border-radius: var(--radius-lg);\n  outline: none;\n  box-shadow: var(--shadow-xl);\n  border: 1px solid var(--color-neutral-200);\n  padding: 20px 20px 24px;\n  z-index: 3;\n}\n\n.animation_enter {\n  opacity: 0.5;\n  transform: translateY(-16px);\n}\n\n.animation_enterActive {\n  opacity: 1;\n  transform: translateY(0px);\n  transition: opacity 150ms ease-out, transform 180ms ease-out;\n}\n\n.animation_exit {\n  opacity: 1;\n  transform: translateY(0px);\n}\n\n.animation_exitActive {\n  opacity: 0.1;\n  transform: translateY(-16px);\n  transition: opacity 150ms linear, transform 180ms linear;\n}\n\n.role {\n  font-size: 16px;\n  margin-top: 12px;\n}\n\n.email {\n  color: var(--accent-color);\n  font-weight: 500;\n  margin-top: 12px;\n}\n\n.logoutButton_base {\n  width: 100%;\n  justify-content: start;\n  margin-top: 32px;\n  padding: 0px 12px;\n}\n\n.logoutButton_icon {\n  --size: 22px;\n  margin-right: 12px;\n}\n\n.logoutButton_text {\n  font-size: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `user-profile-container-IMgqp`,
	"animation_enter": `user-profile-animation_enter-k4vPu`,
	"animation_enterActive": `user-profile-animation_enterActive-KfsH9`,
	"animation_exit": `user-profile-animation_exit-DlGtT`,
	"animation_exitActive": `user-profile-animation_exitActive-nDUT7`,
	"role": `user-profile-role-h_0rm`,
	"email": `user-profile-email-MyOv5`,
	"logoutButton_base": `user-profile-logoutButton_base-CvaJ3`,
	"logoutButton_icon": `user-profile-logoutButton_icon-DNRh0`,
	"logoutButton_text": `user-profile-logoutButton_text-j08eV`
};
export default ___CSS_LOADER_EXPORT___;
